/* import __COLOCATED_TEMPLATE__ from './network-status.hbs'; */
import Component from '@glimmer/component';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-posting-network-status';
const LABEL_CLASS_NAME = `${CLASS_NAME}__label`;
const IN_NETWORK_STATUS_CLASS_NAME = `${LABEL_CLASS_NAME}--in`;
const EXTENDED_NETWORK_STATUS_CLASS_NAME = `${LABEL_CLASS_NAME}--extended`;
const OUT_OF_NETWORK_STATUS_CLASS_NAME = `${LABEL_CLASS_NAME}--out`;

class PostingNetworkStatus extends Component {
  #currentCompanyConnection = createCache(() => {
    return this.args.user.companySellerConnections.find(({ companyId }) => this.args.company.id == companyId);
  });

  #extendedNetwork = createCache(() => {
    return this.args.user.companySellerConnections.reduce((extendedNetwork, connection) => {
      if (connection.inExtendedNetwork) {
        extendedNetwork.push(connection);
      }
      return extendedNetwork;
    }, []);
  });

  get className() {
    return CLASS_NAME;
  }

  get networkStatusClassNames() {
    return clsx(
      LABEL_CLASS_NAME,
      this.isInNetwork && IN_NETWORK_STATUS_CLASS_NAME,
      this.outOfNetwork && OUT_OF_NETWORK_STATUS_CLASS_NAME,
      this.isInExtendedNetwork && EXTENDED_NETWORK_STATUS_CLASS_NAME,
    );
  }

  get currentCompanyConnection() {
    return getValue(this.#currentCompanyConnection);
  }

  get extendedNetwork() {
    return getValue(this.#extendedNetwork);
  }

  get extendedNetworkCompanyName() {
    if (this.extendedNetwork.length > 1) {
      return 'Multiple companies';
    }

    return this.extendedNetwork?.[0].company.name ?? null;
  }

  get isInNetwork() {
    return this.currentCompanyConnection?.invited ?? false;
  }

  get isInExtendedNetwork() {
    return !this.isInNetwork && this.extendedNetwork.length > 0;
  }

  get outOfNetwork() {
    return !this.isInNetwork && this.extendedNetwork.length === 0;
  }
}

export default PostingNetworkStatus;
